import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import AuthNavbar from "components/Navbars/AuthNavbar.js";
import Footer from "components/Footer/Footer.js";

import routes from "routes.js";

import styles from "assets/jss/material-dashboard-pro-react/layouts/authStyle";

import register from "assets/img/register.png";
import login from "assets/img/login.png";
import error from "assets/img/404.png";
import pricing from "assets/img/register_mail.png";

import { useIsAuthenticated } from "hooks/authentication/useIsAuthenticated";
import firebaseApp from "services/firebase";

const useStyles = makeStyles(styles);

export default function Pages(props) {
  const auth = useIsAuthenticated({
    firebaseClient: firebaseApp
  });

  const { ...rest } = props;
  // ref for the wrapper div
  const wrapper: any = React.createRef();
  // styles
  const classes = useStyles();
  React.useEffect(() => {
    document.body.style.overflow = "unset";
    // Specify how to clean up after this effect:
    return function cleanup() {};
  });
  const getRoutes = routes => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === "/anonymous") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };
  const getBgImage = () => {
    if (window.location.pathname.indexOf("/anonymous/register") !== -1) {
      return register;
    } else if (window.location.pathname.indexOf("/anonymous/login") !== -1) {
      return login;
    } else if (window.location.pathname.indexOf("/anonymous/pricing") !== -1) {
      return pricing;
    } else {
      return error;
    }
  };
  const getActiveRoute = routes => {
    let activeRoute = "Default Brand Text";
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };
  if (auth && auth.isRequested && auth.isAuthenticated) {
    return <Redirect to="/" />;
  }
  return (
    <div>
      <AuthNavbar brandText={getActiveRoute(routes)} {...rest} />
      <div className={classes.wrapper} ref={wrapper}>
        <div
          className={classes.fullPage}
          style={{ backgroundImage: "url(" + getBgImage() + ")" }}
        >
          <Switch>
            {getRoutes(routes)}
            <Redirect from="/anonymous" to="/anonymous/login" />
          </Switch>
          <Footer white />
        </div>
      </div>
    </div>
  );
}
